export const PAGE_TITLE = 'Atualização de senha'

export const PAGE_ALERT =
  'Você ainda está usando sua senha inicial. Para deixar a sua conta mais segura, recomendamos criar uma nova senha.'
